import { render, staticRenderFns } from "./shopify_products_page.vue?vue&type=template&id=197435f7&"
import script from "./shopify_products_page.vue?vue&type=script&lang=js&"
export * from "./shopify_products_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports